import { Switches } from '@occc-app/design-system';

import { LimitFormContent } from '../limit-form-content';
import { LimitFormContentLayout } from '../limit-form-content-layout';
import { LimitComponentProps } from '../../types';

export const GlobalActivationLimit = ({ open }: LimitComponentProps) => (
  <LimitFormContentLayout
    title='Global Activation Limit'
    description='Limits activation based on the number of times the offer has generated activation across all memberships'
    action={<Switches name='activation.global.isEnabled' data={{}} />}
    open={open}
  >
    <LimitFormContent name='activation.global' />
  </LimitFormContentLayout>
);
